import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function SuccessIllustration(props: IllustrationProps) {
  return (
    <Frame {...props} tone="success">
      <circle cx="80" cy="80" r="50" stroke={c.s300} strokeWidth="3" strokeDasharray="0.1 8" />
      <circle cx="80" cy="80" r="38" fill={c.s500} />
      <path d="M62 82l13 13 25-28" stroke={c.n0} strokeWidth="9" />
      <circle cx="34" cy="112" r="4" fill={c.a300} />
      <circle cx="126" cy="112" r="4" fill={c.a300} />
    </Frame>
  );
}
